import { Link } from "react-router-dom";

export default function Home() {
  const categories = [
    { to: "/rochii/mireasa", label: "Rochii de mireasă", thumb: "/images/mirese/1.png" },
    { to: "/rochii/cununie-civila", label: "Cununie civilă", thumb: "/images/cununie/1.png" },
    { to: "/rochii/domnisoara-de-onoare", label: "Domnișoară de onoare", thumb: "/images/domnisoara/1.png" },
    { to: "/rochii/cocktail", label: "Cocktail", thumb: "/images/cocktail/1.png" },
    { to: "/rochii/seara", label: "Rochii de seară", thumb: "/images/seara/1.png" },
    { to: "/rochii/ocazie", label: "Ocazie", thumb: "/images/ocazie/1.png" },
    { to: "/rochii/revelion", label: "Revelion", thumb: "/images/revelion/1.png" },
  ];

  const onImgError = (e) => {
    e.currentTarget.src = "/hero.jpg";          // fallback (put it in /public/hero.jpg)
    e.currentTarget.style.objectFit = "cover";
    e.currentTarget.style.background = "#f3f4f6";
  };

  return (
    <>
      {/* ================= HERO ================= */}
      <section
        id="hero"
        className="
    relative isolate overflow-hidden
    w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]
    min-h-[100dvh]
    flex items-center
  "
        style={{
          // if your navbar is NOT fixed, remove the mt- classes above, leave min-h as is.
        }}
      >
        {/* Background image */}
        <div className="absolute inset-0 -z-10">
          <img
            src="/images/hero.jpg"
            alt="TytyStyle – rochie de mireasă"
            className="w-full h-full object-cover"
            loading="eager"
            fetchPriority="high"
            draggable="false"
            onError={onImgError}
          />
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black/70 to-transparent" />
        </div>

        {/* Hero content */}
        <div className="max-w-6xl mx-auto px-6 py-16 md:py-24 w-full">
          <div className="text-center">
            <p className="uppercase tracking-[0.25em] text-white/80 text-xs md:text-sm">
              Atelier de rochii pe comandă
            </p>
            <h1 className="mt-3 text-white text-4xl md:text-6xl font-extrabold leading-tight">
              Eleganță făcută <span className="text-white/90">pe măsura ta</span>
            </h1>
            <p className="mt-4 text-white/90 md:text-lg max-w-2xl mx-auto">
              Materiale premium, croi personalizat și finisaje impecabile — pentru fiecare moment care contează.
            </p>

            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link
                to="/portofoliu"
                className="rounded-xl bg-white text-gray-900 px-6 py-3 font-semibold shadow hover:shadow-md"
              >
                Vezi portofoliul
              </Link>
              <Link
                to="/contact"
                className="rounded-xl bg-black/70 text-white px-6 py-3 font-semibold border border-white/30 hover:bg-black/80"
              >
                Programează o probă
              </Link>
            </div>

            {/* badges */}
            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto">
              {[
                "Croi personalizat",
                "Consultanță stil",
                "Materiale premium",
                "Termene clare",
              ].map((b) => (
                <div
                  key={b}
                  className="rounded-xl border border-white/20 bg-white/5 text-white/90 text-sm py-2"
                >
                  {b}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ================= CATEGORIES ================= */}
      <section id="categories" className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex items-end justify-between">
            <h2 className="text-2xl md:text-3xl font-bold">Alege categoria</h2>
            <Link to="/portofoliu" className="text-sm font-medium underline underline-offset-4">
              Vezi toate modelele
            </Link>
          </div>

          <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {categories.map((c) => (
              <Link
                key={c.to}
                to={c.to}
                className="group rounded-2xl overflow-hidden border bg-white"
              >
                <div className="aspect-[4/3] bg-gray-100">
                  <img
                    src={c.thumb}
                    alt={c.label}
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300"
                    loading="lazy"
                    onError={onImgError}
                  />
                </div>
                <div className="p-4">
                  <div className="font-semibold">{c.label}</div>
                  <div className="text-xs text-gray-500">Descoperă modele</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FEATURED / PORTFOLIO STRIP ================= */}
      <section className="py-12 md:py-16 bg-neutral-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-2xl md:text-3xl font-bold">Lucrări recente</h2>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {[1,2,3,4].map((n) => (
              <div key={n} className="aspect-[3/4] rounded-xl overflow-hidden bg-gray-100">
                <img
                  src={`/images/portofoliu/${n}.png`}
                  alt={`Model ${n}`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => (e.currentTarget.style.opacity = 0.15)}
                />
              </div>
            ))}
          </div>
          <div className="mt-6">
            <Link
              to="/portofoliu"
              className="inline-flex items-center gap-2 text-sm font-medium underline underline-offset-4"
            >
              Vezi portofoliul complet
              <svg width="16" height="16" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2"/></svg>
            </Link>
          </div>
        </div>
      </section>

      {/* ================= TESTIMONIALS ================= */}
      <section className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-2xl md:text-3xl font-bold">Ce spun clientele</h2>
          <div className="mt-6 grid md:grid-cols-3 gap-4 md:gap-6">
            {[
              ["„Rochia a fost exact cum mi-am dorit.”", "Andreea • București"],
              ["„Atenție incredibilă la detalii!”", "Ioana • Cluj"],
              ["„Proba a fost ușoară, comunicare excelentă.”", "Maria • Constanța"],
            ].map(([q, n]) => (
              <figure key={n} className="rounded-2xl border bg-white p-5">
                <blockquote className="text-gray-700">{q}</blockquote>
                <figcaption className="mt-3 text-sm text-gray-500">{n}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-14 md:py-20 relative overflow-hidden">
        <div className="absolute inset-0 -z-10 bg-gradient-to-r from-pink-50 via-rose-50 to-pink-50" />
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold">
            Gata să-ți croim rochia perfectă?
          </h2>
          <p className="mt-2 text-gray-600 max-w-2xl mx-auto">
            Scrie-ne sau programează o probă — discutăm stilul, materialele și detaliile care te avantajează.
          </p>
          <div className="mt-6 flex gap-3 justify-center">
            <Link to="/contact" className="px-6 py-3 rounded-xl bg-black text-white font-semibold hover:bg-gray-900">
              Programează o probă
            </Link>
            <Link to="/servicii" className="px-6 py-3 rounded-xl border font-semibold hover:bg-white">
              Vezi serviciile
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
